import { Skeleton, Tab, Tabs } from '@heroui/react';
import { List, ViewGrid } from 'iconoir-react';
import { useQueryState } from 'nuqs';

import { useContentHeaderContext } from './ContentHeaderContext';

export type ContentHeaderViewToggleProps = {
  'data-testid'?: string;
};

export function ContentHeaderViewToggle(props: ContentHeaderViewToggleProps) {
  const { 'data-testid': dataTestId } = props;
  const [view, setView] = useQueryState('view', {
    defaultValue: 'grid'
  });

  const { isLoaded } = useContentHeaderContext('ContentHeaderViewToggle');

  if (!isLoaded) {
    return <Skeleton className='h-[28x] w-[64px] rounded-md' />;
  }

  return (
    <Tabs
      aria-label='View toggle'
      variant='bordered'
      className=''
      classNames={{
        tabList: 'gap-1 p-[2px] bg-surface-container-low relative'
      }}
      defaultSelectedKey={view}
      onSelectionChange={key => setView(key as string)}
      data-testid={dataTestId}
    >
      <Tab
        key='grid'
        className='h-6 w-7 px-1.5 py-1'
        title={<ViewGrid className='icon-smallest' />}
      />
      <Tab
        key='list'
        className='h-6 w-7 px-1.5 py-1'
        title={<List className='icon-smallest' />}
      />
    </Tabs>
  );
}
